module.exports = __webpack_public_path__ + "img/milan.d16abdc9.jpg";